module.exports = __webpack_public_path__ + "img/epigraphdb-short.548f1d9c.png";